import React from "react"
import { useSearchParams } from "react-router-dom"
import useSWR from "swr"
import { NetworkApi } from "../../../apis"
import { LIST_STORAGE_KEY } from "../product-list/utils"
import { ALL_SUPPLIERS } from "../supplier-select"

const STORAGE_KEY = `${LIST_STORAGE_KEY}.supplierId`

const readCatalogSupplier = (): string => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? String(JSON.parse(raw)) : ""
  } catch {
    return ""
  }
}

/** The buyer's suppliers, from the same request (and SWR key) as the catalogue page. */
export function useBuyerSuppliers(enabled: boolean) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, isLoading } = useSWR<any[]>(enabled ? `/ord/network/select/all-suppliers` : null, async () => {
    try {
      const res = await NetworkApi.select({ regNumber: "", partnerName: "", limit: 1000 })
      return res || []
    } catch {
      return []
    }
  })
  return { suppliers: data || [], isLoading }
}

/**
 * The supplier B25 screens work against: `?supplier=` from the catalogue
 * buttons, else the catalogue's current pick (sessionStorage), else the first.
 * A change is written back so the catalogue opens on the same supplier.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useSupplierChoice(suppliers: any[]) {
  const [params] = useSearchParams()
  const [picked, setPicked] = React.useState<string>(() => params.get("supplier") || readCatalogSupplier())

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const valid = picked && picked !== ALL_SUPPLIERS && suppliers.some((s: any) => s.id === picked)
  const supplierId: string = valid ? picked : suppliers[0]?.id || ""
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const supplier = suppliers.find((s: any) => s.id === supplierId) || null

  const setSupplierId = React.useCallback((id: string) => {
    setPicked(id)
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(id))
    } catch {
      /* ignore quota */
    }
  }, [])

  return { supplierId, supplier, setSupplierId }
}
